import React, { PureComponent } from 'react';
import {connect} from 'dva';
import { Button, Modal, Icon } from 'antd';
import GlobalFooter from '../components/GlobalFooter';
import styles from './BindLayout.less';
import musicLogo from '../assets/music-logo.png'

const closePage = () => {
  window.pener = null;
  window.open('', '_self');
  window.close();
}

@connect((state, props) => ({
  tools: state.tools,
  search: props.location.search,
}))

export default class AccountBind extends PureComponent {
  componentDidMount() {
    const { search } = this.props;
    const params = search && search.slice(1).split('&').reduce((obj, item) =>  {
      const tmp = item.split('=');
      obj[tmp[0]] = tmp[1];
      return obj;
    }, {});
    const code = (params && params.code) || ''
    code && this.bindAccount({ code });
  }

  bindAccount(params) {
    return new Promise(resolve => {
      this.props.dispatch({
        type: 'tools/bindAccount',
        payload: params,
        callback: () => {
          resolve();
        },
      })
    });
  }

  render() {
    const { accountBindInfo } = this.props.tools;
    return (
      <div className={styles.bindWrap}>
        <h2 className={styles.title}>
          <img src={musicLogo} alt="云音乐" width="220" height="58" />
        </h2>
        <div className={styles.content}>
          { accountBindInfo ? (
            <div>
              <p><i className={styles.successIco} /></p>
              <p className={styles.descripe}>云音乐账号授权成功</p>
            </div>
          ) : (
            <div>
              <p ><i className={styles.failedIco} /></p>
              <p className={styles.descripe}>云音乐授权失败</p>
            </div>
          ) }
          <p className={styles.tip}>请关闭本页</p>
        </div>
        <GlobalFooter
          copyright={
            <div>
              Copyright <Icon type="copyright" /> 网易公司版权所有©1997-至今 ICP证浙B2-201611021
            </div>
          }
        />
      </div>
    );
  }
}
